
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cricket-polls",
      function () {
        return require("private-next-pages/cricket-polls/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cricket-polls"])
      });
    }
  